/* Deniz Doğal Taş — Test tanımları 4/4: Enerji
 * Çakra Analizi
 */
(function () {
  "use strict";
  var T = (window.DENIZ_TESTLER = window.DENIZ_TESTLER || {});
  var Z = window.DZ;

  var CAKRA = {
    "kök":    { ad: "Kök Çakra", sanskrit: "Muladhara", renk: "#E53E3E", tema: "Güven, aidiyet, yere basmak",
      acik: "Kendini güvende hissediyorsun. Maddi kaygı seni yönetmiyor, ait olduğun bir zemin var.",
      kapali: "Temel güvenlik hissin zayıf. Para, barınma ve gelecek kaygısı zihninin arka planında sürekli çalışıyor. Yere basamama hâli, kararlarını erteletiyor.",
      soru: "Kendini ait hissettiğin bir yer var mı?" },
    "sakral": { ad: "Sakral Çakra", sanskrit: "Svadhisthana", renk: "#DD6B20", tema: "Yaratıcılık, haz, duygu akışı",
      acik: "Üretkenliğin akıyor, hazza kendini kapatmıyorsun. Duygular sende tıkanmadan geçiyor.",
      kapali: "Yaratıcılığın tıkalı. Zevk almak sana suçluluk veriyor ya da hiçbir şeyden tat alamıyorsun. Duygular içeride birikiyor, dışarı akmıyor.",
      soru: "En son ne zaman sırf keyif için bir şey yaptın?" },
    "solar":  { ad: "Solar Çakra", sanskrit: "Manipura", renk: "#D69E2E", tema: "İrade, özgüven, kişisel güç",
      acik: "İradene güveniyorsun. Hayır diyebiliyor, kendi kararını savunabiliyorsun.",
      kapali: "Kişisel gücün zayıflamış. Karar vermekte zorlanıyor, başkalarının onayına ihtiyaç duyuyorsun. Hayır demek sana orantısız derecede zor geliyor.",
      soru: "Son bir ayda kaç kez istemediğin bir şeye evet dedin?" },
    "kalp":   { ad: "Kalp Çakra", sanskrit: "Anahata", renk: "#38A169", tema: "Sevgi, şefkat, bağ kurma",
      acik: "Sevmeye ve sevilmeye açıksın. Şefkatin hem başkalarına hem kendine uzanıyor.",
      kapali: "Kalp bölgesi savunmada. Yakınlığa kapıyı tam açmıyorsun; eski bir kırgınlık hâlâ orada duruyor. Affetmek sana teslim olmak gibi geliyor.",
      soru: "Affedemediğin biri var mı — kendin dahil?" },
    "boğaz":  { ad: "Boğaz Çakra", sanskrit: "Vishuddha", renk: "#3182CE", tema: "İfade, hakikat, ses",
      acik: "Söylemek istediğini söyleyebiliyorsun. Sesin ile içindekiler arasında büyük bir açık yok.",
      kapali: "Söylenmemiş cümleler birikmiş. Düşündüğünü söyleyememek, sonradan aklında konuşmalar kurmak, boğazında düğüm hissi — bu çakranın klasik tarifi budur.",
      soru: "Kime, ne zamandır söyleyemediğin bir şey var?" },
    "alın":   { ad: "Alın Çakra", sanskrit: "Ajna", renk: "#5A67D8", tema: "Sezgi, iç görü, vizyon",
      acik: "Sezgin çalışıyor ve ona güveniyorsun. Büyük resmi görebiliyorsun.",
      kapali: "Sezgin ile mantığın çatışıyor ve mantık kazanıyor. İçine doğanı görmezden geliyor, sonra haklı çıktığında pişman oluyorsun. Yön duygunu kaybetmiş hissediyorsun.",
      soru: "Son kararında içine doğanı dinledin mi?" },
    "taç":    { ad: "Taç Çakra", sanskrit: "Sahasrara", renk: "#805AD5", tema: "Anlam, bütünlük, bağlanma",
      acik: "Hayatında bir anlam duygusu var. Kendinden büyük bir şeye bağlı hissediyorsun.",
      kapali: "Anlam duygun zayıflamış. 'Bütün bunlar ne için' sorusu sık geliyor. Kopukluk hissi, en çok kalabalıkta beliriyor.",
      soru: "Son zamanlarda hayatın sana anlamlı geliyor mu?" },
  };

  var CAKRA_SIRA = ["kök", "sakral", "solar", "kalp", "boğaz", "alın", "taç"];

  /* ============ 10. ÇAKRA ANALİZİ ============ */
  T["cakra-analizi"] = {
    ad: "Çakra Analizi",
    ustBaslik: "Yedi Merkez",
    kapak: "kapak-cakra.png",
    video: "cakra-dongu.mp4",
    ozet: "Yedi enerji merkezinin hangisi açık, hangisi tıkalı? On dört soruyla tüm sistemin haritasını çıkarıp en çok desteğe ihtiyaç duyan merkezi belirliyoruz.",
    sure: "6 dakika",
    ciktiEtiket: "Yedi merkez haritası",
    girdiler: ["ad"],
    hesapSatirlari: [
      "Yedi merkez taranıyor…",
      "Kök ve sakral ölçülüyor…",
      "Solar ve kalp değerlendiriliyor…",
      "Boğaz, alın ve taç okunuyor…",
      "En tıkalı merkez belirleniyor…",
      "Merkez taşları eşleştiriliyor…",
    ],
    sorular: (function () {
      var S = [];
      var tanim = [
        ["kök", "Maddi geleceğin konusunda ne hissediyorsun?", ["Genelde güvendeyim", "Zaman zaman kaygılanırım", "Sürekli arka planda bir endişe var", "Hiç güvende hissetmiyorum"]],
        ["kök", "Kendini ait hissettiğin bir yer ya da topluluk var mı?", ["Evet, net", "Kısmen", "Pek değil", "Hiç yok"]],
        ["sakral", "En son ne zaman sırf keyif için bir şey yaptın?", ["Bu hafta", "Bu ay", "Hatırlamıyorum", "Keyif almak bana suçluluk veriyor"]],
        ["sakral", "Yaratıcı üretimin nasıl?", ["Akıyor", "Ara ara geliyor", "Tıkalı", "Uzun zamandır hiç"]],
        ["solar", "İstemediğin bir şeye hayır diyebiliyor musun?", ["Rahatlıkla", "Zorlanarak ama diyorum", "Genelde diyemem", "Neredeyse hiç"]],
        ["solar", "Kendi kararına güvenin?", ["Tam", "Çoğunlukla", "Onay ararım", "Kendi kararımdan hep şüphe ederim"]],
        ["kalp", "Affedemediğin biri var mı?", ["Yok", "Var ama üstesinden geldim", "Var, hâlâ ağır", "Birden fazla var"]],
        ["kalp", "Yakınlığa kapın ne kadar açık?", ["Açık", "Seçerek açık", "Genelde kapalı", "Kimseyi yaklaştırmam"]],
        ["boğaz", "Düşündüğünü söyleyebiliyor musun?", ["Genelde evet", "Ortama göre", "Çoğu zaman söyleyemem", "Neredeyse hiç"]],
        ["boğaz", "Sonradan aklında konuşma kurar mısın?", ["Nadiren", "Bazen", "Sık sık", "Sürekli"]],
        ["alın", "Sezgine ne kadar güvenirsin?", ["Çok", "Kısmen", "Az", "Hiç, mantığa bakarım"]],
        ["alın", "Hayatında bir yön duygun var mı?", ["Net", "Bulanık ama var", "Kaybettim", "Hiç olmadı"]],
        ["taç", "Hayat sana anlamlı geliyor mu?", ["Evet", "Çoğunlukla", "Zaman zaman sorguluyorum", "Sık sık anlamsız geliyor"]],
        ["taç", "Kendinden büyük bir şeye bağlı hisseder misin?", ["Evet", "Bazen", "Nadiren", "Hayır"]],
      ];
      tanim.forEach(function (t) {
        S.push({
          metin: t[1],
          secenekler: t[2].map(function (e, i) {
            var p = {}; p[t[0]] = 3 - i; // 3,2,1,0 — yüksek puan açık merkez
            return { etiket: e, puan: p };
          }),
        });
      });
      return S;
    })(),
    sonuc: function (girdi, cevaplar) {
      var ad = Z.ilkAd(girdi.ad);
      var p = Z.puanTopla(cevaplar);
      CAKRA_SIRA.forEach(function (c) { if (!p[c]) p[c] = 0; });

      // Her merkez en fazla 6 puan alabilir (2 soru x 3)
      var enTikali = CAKRA_SIRA.slice().sort(function (a, b) { return p[a] - p[b]; })[0];
      var enAcik = CAKRA_SIRA.slice().sort(function (a, b) { return p[b] - p[a]; })[0];
      var TK = CAKRA[enTikali], AC = CAKRA[enAcik];

      var taslar = Z.birlestir(
        Z.cakraTaslari(enTikali, 4),
        Z.cakraTaslari(CAKRA_SIRA.slice().sort(function (a, b) { return p[a] - p[b]; })[1], 2),
        Z.niyetTaslari(["denge", "aritma"], 2)
      );
      var bilgi = (window.DENIZ_VERI && window.DENIZ_VERI.tasBilgi) || {};

      var olcumler = CAKRA_SIRA.map(function (c) {
        return { ad: CAKRA[c].ad, oran: p[c] / 6, renk: CAKRA[c].renk };
      });

      var toplam = CAKRA_SIRA.reduce(function (a, c) { return a + p[c]; }, 0);
      var genel = Math.round((toplam / 42) * 100);

      return {
        ustBaslik: "Çakra Haritan",
        baslik: TK.ad + " Desteğe İhtiyaç Duyuyor",
        altBaslik: "Genel akış %" + genel + " · en açık merkez: " + AC.ad,
        vurgu: "Sistemde zayıf halka neyse, akış oradan kesilir.",
        rozetler: [
          { etiket: "En tıkalı", deger: TK.ad.split(" ")[0] },
          { etiket: "En açık", deger: AC.ad.split(" ")[0] },
          { etiket: "Genel akış", deger: "%" + genel },
          { etiket: "Sanskrit", deger: TK.sanskrit },
        ],
        metin: [
          ad + ", çakra sistemi kadim Hint geleneğinde bedenin yedi enerji merkezini tarif eder. Bu bir tıbbi model değil, sembolik bir haritadır — ama tarif ettiği hâller tanıdıktır: yere basamamak, söyleyememek, hissedememek.",
        ],
        bolumler: [
          { baslik: "En çok desteğe ihtiyaç duyan merkez",
            vurgu: TK.ad + " · " + TK.tema,
            paragraflar: [
              TK.kapali,
              "Bu merkez için sorman gereken soru şu: " + TK.soru + " Cevabı erteliyorsan, tıkanıklığın sebebi büyük ihtimalle orada.",
            ] },
          { baslik: "En açık merkezin",
            paragraflar: [
              AC.ad + " en yüksek puanı aldı. " + AC.acik,
              "Açık merkez bir güç kaynağıdır ama tek başına sistemi taşıyamaz. Çoğu insan güçlü merkezine yaslanıp zayıf olanı görmezden gelir; oysa akış her zaman en dar yerden kesilir.",
            ] },
          { baslik: "Merkezler birbirini nasıl etkiler",
            paragraflar: [
              "Çakralar bağımsız kutular değildir; alttaki bir daralma üsttekini de kısıtlar. Kök çakrası tıkalı bir kişide boğaz çakrası üzerine yapılan çalışma kalıcı olmaz — çünkü kendini güvende hissetmeyen kişi konuşamaz.",
              "Bu yüzden geleneksel sıralama alttan yukarıdır: önce güvenlik (kök), sonra duygu akışı (sakral), sonra irade (solar). Üstteki dört merkez bu üç temel oturmadan istikrarlı çalışmaz.",
              "Senin haritanda " + TK.ad + " en dar nokta. " + (CAKRA_SIRA.indexOf(enTikali) <= 2
                ? "Bu alt bölgede olduğu için doğrudan buradan başlamak doğru olur; temeli kurmadan yukarısıyla uğraşmak zaman kaybıdır."
                : "Bu üst bölgede. Yine de alt merkezlerin puanlarına bakmakta fayda var — orada gizli bir daralma varsa buradaki çalışma yavaş ilerler."),
            ] },
          { baslik: "Sistemin bütünü",
            paragraflar: [
              "Genel akışın %" + genel + ". " + (genel >= 70
                ? "Sistem büyük ölçüde açık. Tek bir merkezde belirgin bir daralma var; onu desteklemek dengeyi hızla toparlar."
                : genel >= 45
                ? "Sistem orta düzeyde. Birden fazla merkezde daralma var ama hiçbiri kritik değil. Sıralı çalışmak — önce alttan başlamak — geleneksel yaklaşımdır."
                : "Sistemde yaygın bir daralma var. Bu genelde uzun süreli bir yorgunluk döneminin ardından görülür. Tek tek merkezlerle uğraşmak yerine, en alttaki tıkalı merkezden başlamak önerilir."),
              "Geleneksel sıralama alttan yukarıya doğrudur: kök sağlam değilse üstteki merkezlerde yapılan çalışma kalıcı olmaz. Senin durumunda " + (CAKRA_SIRA.indexOf(enTikali) <= 2 ? "tıkalı merkez zaten alt bölgede; doğrudan oradan başlamak doğru olur." : "tıkalı merkez üst bölgede; ama alt merkezlerin durumunu da göz önünde tutmak gerekir.") + "",
            ] },
        ],
        golge: { baslik: "Bu harita hakkında", metin: "Çakra okuması bir sağlık değerlendirmesi değildir ve tıbbi bir durumun yerini tutmaz. Bu tablo, kendi hâlini adlandırmak için sembolik bir dil sunar. Fiziksel ya da ruhsal bir şikâyetin varsa doğru adres bir uzmandır." },
        olcumler: olcumler,
        gerekceler: taslar.slice(0, 6).map(function (a) {
          var t = bilgi[a] || {};
          var c = t.cakra ? CAKRA[t.cakra] : null;
          return { ad: t.ad || a, renk: t.renk, metin: (c ? c.ad + " taşı. " : "") + (t.ozet || "") };
        }),
        taslar: taslar,
        urunGiris: TK.ad + " için geleneksel olarak taşınan stoklu ürünler:",
      };
    },
  };

  })();
